import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { uniqBy } from 'lodash';
import ContactForm from './contact_form';
import SocialLink from './social_link';

class Contact extends Component {
  render() {
    const { socialLinks, showContactForm } = this.props;
    const socialLinkColProps = { xs: 10, xsOffset: 1 };
    if (showContactForm) {
      socialLinkColProps.md = 2;
      socialLinkColProps.mdPull = 4;
      socialLinkColProps.lgPull = 5;
      socialLinkColProps.lg = 2;
    } else {
      socialLinkColProps.md = 6;
      socialLinkColProps.mdOffset = 3;
    }

    return (
      <Row>
        {showContactForm && (
          <Col
            xs={10}
            xsOffset={1}
            md={4}
            mdOffset={2}
            mdPush={3}
            lg={4}
            lgOffset={3}
            lgPush={2}
            className="contact-form-container"
          >
            <h3>Contact</h3>
            <ContactForm />
          </Col>
        )}

        <Col {...socialLinkColProps}>
          <h3>Social</h3>
          {socialLinks && Array.isArray(socialLinks) && (
            <div>
              {uniqBy(socialLinks, 'link').map((profile) => (
                <SocialLink key={profile.link} profile={profile} />
              ))}
            </div>
          )}
        </Col>

        <div style={{ marginBottom: '20px' }} />
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    socialLinks: state.social_links,
    showContactForm: state.user_info.can_be_contacted,
  };
};

export default connect(mapStateToProps)(Contact);
